export const transferStatusEnum = {
  NEW: 1,
  APPROVED: 2,
  FINISHED: 3,
  CANCELLED: 4,
  EXPIRED: 5,
  REJECTED: 6,
  NULLIFIED: 7,
  PENDING: 8,
  REQUESTED: 9,
  SENDING: 10,
  PROCESS: 11,
  INCOMPLETE: 12,
}
